export const dealPaymentTypes = {
  CARD: 'Tarjeta',
  RECEIPT: 'Recibo',
  TRANSFER: 'Transferencia',
} as const;